<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:18px;">重熔铅锭，重熔锌锭</span>
        </b>
      </p>
      <p>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">重熔铅锭：</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">Grade #1</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">，</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">
          Grade
          #2(Pb 99%
        </span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">～</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">99.5%)</span>
      </p>
      <p>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">重熔锌锭：</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">Grade #0</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">，</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">
          Grade
          #1(Zn 99%
        </span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">～</span>
        <span style="text-indent:12pt;font-size:12px;font-family:SimSun;">99.5%)</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.crqd">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        crqd: require("../../../assets/img/common/crqd.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/crqd.vue